import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "../../components/static home/static_home.css";
import Slider from "../../components/static home/Slider";
import About from "../../components/static home/About";
import Why from "../../components/static home/Why";
import MarketerSolution from "../../components/static home/MarketerSolution";
import Header from "../../components/static home/Header";
import Where from "../../components/static home/Where";
import CommonQuestions from "../../components/static home/CommonQuestions";
import Says from "../../components/static home/Says";
import Footer from "../../components/static home/Footer";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import FulfillmentSolution from "../../components/static home/FulfilmentSolution";
import Contact from "../../components/static home/Contact";
import { Whatsapp } from "../../components/static home/Whatsapp";

export const FulfillmentLanding = () => {
  const [isSticky, setIsSticky] = useState(false);
  const { i18n, t: _ } = useTranslation("global");
  const { lang } = useParams();

  useEffect(() => {
    AOS.init({
      duration: 800,
      offset: 10,
      once: true,
      easing: "ease-in-out",
    });

    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
    useEffect(() => {
      if (lang && i18n.language !== lang) {
        i18n.changeLanguage(lang);
      }
    }, [lang, i18n]);
  return (
    <div dir={lang === "en" ? "ltr" : "rtl"} style={{ overflow: "hidden" }}>
      {/* Header Section with Metadata */}
      <header>
        <Helmet>
          <title>{_("static_home.title")}</title>
          <meta name="description" content={_("static_home.description")} />
          <meta name="keywords" content={_("static_home.keywords")} />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
          <meta name="robots" content="index, follow" />
          <meta property="og:title" content={_("static_home.title")} />
          <meta
            property="og:description"
            content={_("static_home.description")}
          />
          <meta property="og:type" content="website" />
        </Helmet>
        <Header
          navItems={[
            { labelKey: "fulfillment_landing.header.about", href: "#about" },
            { labelKey: "fulfillment_landing.header.why", href: "#why" },
            { labelKey: "fulfillment_landing.header.where", href: "#where" },
            {
              labelKey: "fulfillment_landing.header.fulfillmentSolution",
              href: "#fulfillmentSolution",
            },
            {
              labelKey: "fulfillment_landing.header.commonQuestions",
              href: "#common-questions",
            },
          ]}
          isSticky={isSticky}
        />
      </header>

      {/* Main Body Section */}
      <main>
        <Slider 
          title={_("fulfillment_landing.slider.title")}
          description={_("fulfillment_landing.slider.description")}
          join_us={_("fulfillment_landing.slider.join_us")}
          subheader={_("fulfillment_landing.slider.subheader")}
          subheaderTitle={_("fulfillment_landing.slider.subheader.title")}
          subheaderSubtitle={_("fulfillment_landing.slider.subheader.subtitle")}
          subheaderDescription={_("fulfillment_landing.slider.subheader.description")}

        />
        <div className="fulfillment-about">
          <About
            isFulfillment={true}
            text={_("fulfillment_landing.about.description")}
          />
        </div>
        <div className="fulfillment-why">
          <Why
            title={_("fulfillment_landing.why.title")}
            description={_("fulfillment_landing.why.description")}
            type="fulfillment_landing"
            conclusion={_("fulfillment_landing.why.conclusion")}
          />
        </div>
        <div className="fulfillment-solution">
          <FulfillmentSolution />
        </div>
        <div className="fulfillment-where">
          <Where />
        </div>
        <div className="fulfillment-questions">
          <CommonQuestions type="fulfillment_landing" />
        </div>
        <div className="fulfillment-contact">
          <Contact />
        </div>
        <div className="fulfillment-says">
          <Says />
        </div>
        <Whatsapp />

      </main>

      {/* Footer Section */}
      <footer>
        <Footer />
      </footer>
    </div>
  );
};
